import { useState } from "react";
import { jsPDF } from "jspdf";

function readAsDataURL(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.readAsDataURL(file);
  });
}

function loadImage(dataUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = dataUrl;
  });
}

export default function ImagesToPdf() {
  const [download, setDownload] = useState(null);
  // { url, filename }

  const convertImagesToPDF = async (fileList) => {
    const files = Array.from(fileList || []);
    if (!files.length) return;

    // 🔹 Nom du PDF basé sur le PREMIER fichier
    const baseName = files[0].name.replace(/\.[^/.]+$/, "");
    const outputName = `${baseName}-convert.pdf`;

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    const pageW = pdf.internal.pageSize.getWidth();
    const pageH = pdf.internal.pageSize.getHeight();

    for (let i = 0; i < files.length; i++) {
      const dataUrl = await readAsDataURL(files[i]);
      const img = await loadImage(dataUrl);

      const imgW = img.width;
      const imgH = img.height;

      // Cover A4 (zoom max, sans marge)
      const scale = Math.max(pageW / imgW, pageH / imgH);
      const drawW = imgW * scale;
      const drawH = imgH * scale;

      const x = (pageW - drawW) / 2;
      const y = (pageH - drawH) / 2;

      if (i > 0) pdf.addPage();

      const type = dataUrl.startsWith("data:image/png") ? "PNG" : "JPEG";
      pdf.addImage(dataUrl, type, x, y, drawW, drawH);
    }

    const blob = pdf.output("blob");
    const url = URL.createObjectURL(blob);

    setDownload({ url, filename: outputName });
  };

  return (
    <section>
      <h2 className="title-button">Convertisseur Images en PDF</h2>
      <small>A4 — zoom maximum — aucune marge blanche</small>

      <input
        type="file"
        accept="image/*"
        multiple
        onChange={(e) => convertImagesToPDF(e.target.files)}
      />

      <div className="output">
        {download && (
          <a href={download.url} download={download.filename}>
            Télécharger le PDF
          </a>
        )}
      </div>
    </section>
  );
}
